<template>
  <div class="ins-main rbcnsystem-main">
		<div class="rbcnsystem-inner">
			<div class="rbcnsystem-content">
				<div class="rbcnsystem-head blackHeading">
					<h1>{{$t('lang_groupHeading_backstage')}}</h1>
					<h3 v-html="$t('lang_groupHeading_backstage_narrative')"></h3>
				</div>
				<div class="rbcnsystem-body">
					<div class="rbcnsystem-body-list" v-show="!contentShow">
						<ul class="rbcnsystem-list">
							<template v-for="(item, index) in info">
								<li class="Toview" :rel="`${index+1}`" :key="index" @click="toView(`${index+1}`)">
									<i :class="`icon-system-0${index+1}`"></i>
									<h1 v-html="$t(`lang_backstage_theme${index+1}`)"></h1>
									<div v-html="$t(`lang_backstage_theme${index+1}_narr`)"></div>
									<button><span>{{$t('iang_mem_clickMore')}}</span><span>▲</span></button>
								</li>
							</template>
						</ul>
					</div>
					<div class="rbcnsystem-body-content" :data-tabs="selectView" v-show="contentShow">
						<div class="rbcnsystem-switch" @click="contentSwitch(false)">{{$t('lang_backstage_home')}}</div>
						<div class="rbcnsystem-body-container">
							<ul class="rbcnsystem-container-list">
								<template v-for="(item, index) in info">
									<li :class="{'active':`${index+1}` === selectView}" :key="index" @click="toView(`${index+1}`)"><i :class="`icon-system-0${index+1}`"></i><span v-html="$t(`lang_backstage_theme${index+1}`)"></span></li>
								</template>
								<select name="" id="rbcnsystem-container-select" v-model="selectView">
									<template v-for="(item, index) in info">
										<option :value="`${index+1}`" v-html="$t(`lang_backstage_theme${index+1}`)" :key="index"></option>
									</template>
								</select>
							</ul>
							<div class="rbcnsystem-container-content">
								<div class="rbcnsystem-switch-inner" @click="contentSwitch(false)"><span><i class="icon-29"></i>{{$t('lang_backstage_home')}}</span></div>
								<template v-for="(item,i) in info">
									<section :key="i" :data-tabs="`${i+1}`" v-show="`${i+1}` === selectView">
										<div class="content-head">
											<h1 v-html=$t(item.title)></h1>
											<h4><span class="now">{{itemsStatus[i][0]}}</span>/<span class="all">{{itemsStatus[i][1]}}</span></h4>
										</div>
										<button class="btn-prev" @click="changePage(i,'prev')" v-if="itemsStatus[i][1]>1">
											<img src="@img/rbcnsystem/arrow_prev.png" alt="">
										</button>
										<button class="btn-next" @click="changePage(i,'next')" v-if="itemsStatus[i][1]>1">
											<img src="@img/rbcnsystem/arrow_next.png" alt="">
										</button>
										<ul class="rbcnsystem-container-slider clearfix">
											<li v-for="(child, j) in item.child" :key="j" v-show="Number(`${j+1}`) === itemsStatus[i][0]">
												<div class="rbcnsystem-container-slider-text">
													<h1 v-html=$t(child.title)></h1>
													<div v-html=$t(child.narr)></div>
												</div>
												<div class="rbcnsystem-container-slider-img"><img :src="require(`@img/${nowLangx}/${child.img}`)" alt=""></div>
											</li>
										</ul>
									</section>
								</template>
							</div>
						</div>
						<i :class="selectView/10 < 1 ? 'icon-system-0' + selectView : 'icon-system-' + selectView"></i>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import infoData from '@data/rbcnsystem.json'
import {mapGetters} from 'vuex'
export default {
  name: 'Rbcnsystem',
  data(){
    return{
      info: [],
			selectView: "1",
			itemsStatus: [],
			contentShow: false,
    }
  },
  methods:{
    toView(i){
			this.selectView = i
			this.contentSwitch(true)
			this.$set(this.itemsStatus[i-1], 0, 1);
		},
		getItemCount(index){
			return this.info[index].child.length
		},
		itemsStatusCount(){
			const $this = this
			$this.info.forEach(function(item, index){
				$this.itemsStatus.push([1,$this.getItemCount(index)])
			});
		},
		changePage(index,navi){
			const $this = this
			if($this.getItemCount(index) === 1) return;
			const count = navi === 'next' ? 1 : -1
			if($this.itemsStatus[index][0] + count <= 0){
				$this.$set($this.itemsStatus[index], 0, $this.getItemCount(index));
			}else if ($this.itemsStatus[index][0] + count > $this.itemsStatus[index][1]) {
				$this.$set($this.itemsStatus[index], 0, 1);
			}else {
				$this.$set($this.itemsStatus[index], 0, $this.itemsStatus[index][0] + count);
			}
		},
		contentSwitch(boo){
			this.contentShow = boo
		}
  },
  watch:{
    selectView(){
      this.toView(this.selectView)
    },
	},
	computed:{
		...mapGetters(['nowLangx'])
	},
  mounted(){
		this.info = infoData;
		this.itemsStatusCount()
		this.$store.dispatch('setLoadshow',false)
  },
  beforeDestroy(){
    this.$store.dispatch('setLoadshow',true)
  }
}
</script>
<style lang="sass">
	@import '@css/rbcnsystem.sass'
</style>